import React, { useCallback, useContext } from 'react';
import { initialState, reducer } from './dialogReducer';
import { jsx as _jsx } from "react/jsx-runtime";
export const DialogStateContext = /*#__PURE__*/React.createContext(initialState);
export const DialogDispatchContext = /*#__PURE__*/React.createContext(undefined);
export const DialogProvider = ({
  children
}) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  return /*#__PURE__*/_jsx(DialogStateContext.Provider, {
    value: state,
    children: /*#__PURE__*/_jsx(DialogDispatchContext.Provider, {
      value: dispatch,
      children: children
    })
  });
};
export const useDialogDispatch = () => {
  const context = useContext(DialogDispatchContext);
  if (context === undefined) {
    throw new Error('useDialogDispatch must be used within a DialogProvider');
  }
  return context;
};
export const useDialogState = () => {
  const state = useContext(DialogStateContext);
  if (state === undefined) {
    throw new Error('useDialogState must be used within a DialogProvider');
  }
  return state;
};
export const useShowDialog = () => {
  const dispatch = useDialogDispatch();
  return useCallback(dialog => {
    dispatch({
      type: 'show-dialog',
      dialog
    });
  }, [dispatch]);
};
export const useHideDialog = () => {
  const dispatch = useDialogDispatch();
  return useCallback(() => {
    dispatch({
      type: 'remove-dialog'
    });
  }, [dispatch]);
};